import { Button, Text } from '@fable/components'
import { css, cx, useTheme } from '@fable/theme'
import { useEffect, useState } from 'react'

interface Props extends React.HTMLProps<HTMLDivElement> {
  description: string
  maxLength?: number
  truncate?: number
  buttonClass?: string
}

export const ExpandableDescription = ({
  description,
  maxLength = 1000,
  truncate = 10,
  buttonClass = '',
  ...nativeProps
}: Props) => {
  const { colors, nativeOverrides } = useTheme()
  const [expandable, setExpandable] = useState(false)
  const [expanded, setExpanded] = useState(false)

  useEffect(() => {
    if (description.length > maxLength) {
      setExpandable(true)
    }

    return () => {
      setExpandable(false)
    }
  }, [description.length, maxLength])

  if (!description || !description.length) return null

  return (
    <div {...nativeProps}>
      <div>
        <Text
          className={css`
            position: relative;
            overflow: hidden;
            white-space: break-spaces;
          `}
          type="body"
          sizing="M"
          truncate={expanded ? null : truncate}
        >
          <span dangerouslySetInnerHTML={{ __html: description }} />
        </Text>
      </div>
      {expandable ? (
        <Button
          className={cx(
            css`
              ${nativeOverrides.buttonClear};
              margin-top: 8px;
              font-size: 12px;
              color: ${colors.uiGraphiteLight};
            `,
            buttonClass
          )}
          onClick={() => setExpanded(!expanded)}
          negative
        >
          See {expanded ? 'less' : 'more'}
        </Button>
      ) : null}
    </div>
  )
}
